import { useQuery } from "@apollo/client";
import { graphql } from "~/gql";

export const FIND_LATEST_SETTINGS_QUERY = graphql(/* GraphQL */ `
  query FindLatestSettings {
    findLatestSettings {
      ...SettingsParts
    }
  }
`);

export function useLatestSettingsQuery() {
  return useQuery(FIND_LATEST_SETTINGS_QUERY);
}
